import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar1 = ({ branding }) => {
  const { user } = useAuth();
  const phoneNumber = user?.phoneNumber || '+1 (555) 123-4567';
  const email = user?.email || 'info@travellease.com';

  // --- THIS IS THE NEW LOGIC ---
  // We define a style object that reads from our CSS variables.
  // We provide a fallback color (e.g., '#f8f9fa') in case the variable is not defined.
  const topBarStyle = {
    backgroundColor: 'var(--topbar-bg-color, #f8f9fa)',
    color: 'var(--topbar-text-color, #212529)',
  };

  const linkStyle = {
    color: 'var(--topbar-text-color, #212529)', // Links should also use the text color
    textDecoration: 'none',
  };

  return (
    // We apply the main style object here.
    // We keep the Bootstrap padding classes for consistency.
    <div className="top-bar py-2 px-4" style={topBarStyle}>
      <div className="container-fluid d-flex justify-content-between align-items-center">
        
        {/* Left Side: Social Media Icons */}
        <div className="d-flex gap-3">
          <a href="#" style={linkStyle}><FaFacebookF /></a>
          <a href="#" style={linkStyle}><FaInstagram /></a>
          <a href="#" style={linkStyle}><FaTwitter /></a>
        </div>

        {/* Right Side: Contact Information */}
        <div className="d-flex align-items-center gap-4">
          <a href={`tel:${phoneNumber}`} style={linkStyle} className="d-flex align-items-center gap-2">
            <FaPhoneAlt />
            <span>{phoneNumber}</span>
          </a>
          <a href={`mailto:${email}`} style={linkStyle} className="d-flex align-items-center gap-2">
            <FaEnvelope />
            <span>{email}</span>
          </a>
        </div>

      </div>
    </div>
  );
};

export default TopBar1;